import { PAGE_TYPE_CATEGORY } from 'shared/consts'
import {
  CAT_MORE_PRODUCTS_ON_FIRST_CSW,
  CSW_PRODUCT_CLICK,
  CSW_SHOW_MORE_CLICK,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperiments,
} from 'shared/experiments/utils/experiments'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'

const bindTracking = () => {
  const xsellWidget = document.querySelector(
    '[data-clientside-api-call~="fetchCrossSell"]'
  )
  xsellWidget?.addEventListener('click', event => {
    const el = event.target as HTMLElement
    if (el.closest('[data-clientside-hook~="slider__item"]')) {
      trackEvent(CSW_PRODUCT_CLICK)
    }

    if (el.closest('[data-clientside-hook~="showMoreButton"]')) {
      trackEvent(CSW_SHOW_MORE_CLICK)
    }
  })
}

export default () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { experiments = [], pageType = '' } =
    publicRuntimeConfig?.pageProperties || {}
  const { variant, isEnabled } =
    getExperiments([CAT_MORE_PRODUCTS_ON_FIRST_CSW], experiments)[0] || {}
  if (pageType !== PAGE_TYPE_CATEGORY || !isEnabled) {
    return
  }
  void activateExperiment(CAT_MORE_PRODUCTS_ON_FIRST_CSW)
  if (variant === EXPERIMENT_VARIATION.V1) {
    bindTracking()
  }
}
